import { Component } from "@angular/core";
import { XOField } from './xo-field.component';

@Component({
    selector: "xo-field-longstring",
    templateUrl: "./xo-field-longstring.component.html"
})
export class XOFieldLongString extends XOField {
}
